import React, { useState, useEffect } from 'react';
import { BiPlus } from 'react-icons/bi';
import { CgClose } from 'react-icons/cg';
import axios from 'axios';
import Select from '../../../../../components/Form/Select';
import Modal from '../../../../../components/Modal';
import {RESUME_API_END_POINT} from "../../../../../utils/constant"
import { useOutletContext } from 'react-router-dom';
import ButtonBlack from '../../../../../components/Buttons/ButtonBlack';

const Language = ({data}) => {
    const [showModal, setShowModal] = useState(false);
    const [languages, setLanguages] = useState([]);
    const [editingLanguage, setEditingLanguage] = useState(null);
    const {showNotif, setShowNotif} = useOutletContext()
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (data) {
            setLanguages(data?.languages)
        }
        }, [data]);

    // Open modal for adding or editing language
    const handleOpenModal = (language = null) => {
        setEditingLanguage(language);
        setShowModal(true);
    };

    // Handle save action for add/edit modal
    const handleSaveLanguage = async () => {
        if (editingLanguage?.id) {
            // Update existing language
            await editLanguage(editingLanguage);
        } else {
            // Add new language
            await addLanguage(editingLanguage);
        }
        setShowModal(false);
        setEditingLanguage(null);
    };

    // Add language to the database
    const addLanguage = async (newLanguage) => {
        setIsLoading(true)
        try {
            const response = await axios.post(RESUME_API_END_POINT+'/language/save',  {...newLanguage, resume_id: data?.id});
            if (response.data?.language) {
            setLanguages([...languages, response.data?.language]);
            setShowNotif({ ...showNotif, variant: "success", message: response?.data?.message, show: true });
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            setShowNotif({ ...showNotif, variant: "danger", message: "Une erreur est survenue", show: true });
            console.error("Error adding language:", error);
        }
    };

    // Edit existing language in the database
    const editLanguage = async (updatedLanguage) => {
        setIsLoading(true)
        try {
            const response = await axios.put(`${RESUME_API_END_POINT}/language/${updatedLanguage.id}`, updatedLanguage);
            if (response.data?.language) {
                setLanguages(languages.map(lang => lang.id === response.data?.language?.id ? response.data?.language : lang));
                setShowNotif({ ...showNotif, variant: "success", message: response?.data?.message, show: true });
            }
            setIsLoading(false)
        
        } catch (error) {
            setIsLoading(false)
            setShowNotif({ ...showNotif, variant: "danger", message: "Une erreur est survenue", show: true });
            console.error("Error editing language:", error);
        }
    };

    // Delete language from the database
    const handleDeleteLanguage = async (id) => {
        try {
            await axios.delete(`${RESUME_API_END_POINT}/language/${id}`);
            setLanguages(languages.filter(lang => lang.id !== id));
        } catch (error) {
            console.error("Error deleting language:", error);
        }
    };

    return (
        <div className="flex-col text-start border p-4 rounded-md w-full">
            <div className="flex justify-between items-center mb-4">
                <div className="font-semibold">Langues</div>
                <button onClick={() => handleOpenModal(null)} className="bg-neutral-50 border rounded-sm p-1">
                    <BiPlus className="w-5 h-5 text-neutral-500" />
                </button>
            </div>

            <div className="flex items-center gap-2 flex-wrap">
                {languages?.map((lang) => (
                    <div key={lang?.id} className="py-2 pl-4 pr-3.5 text-primary-text flex gap-4 items-center border rounded-sm">
                        <div className="w-8 h-8 bg-primary-black flex items-center justify-center text-white rounded-full uppercase">
                            {lang?.title?.slice(0, 2).toUpperCase()}
                        </div>
                        <div className="flex flex-col gap-y-1 text-primary-black">
                            <p className="text-start font-semibold">{lang?.title}</p>
                            <p>{lang?.merit}</p>
                        </div>
                        <button onClick={() => handleDeleteLanguage(lang?.id)} className="hover:bg-neutral-400 hover:text-white rounded-full p-0.5">
                            <CgClose />
                        </button>
                        <button onClick={() => handleOpenModal(lang)} className="ml-2 text-blue-500">Modifier</button>
                    </div>
                ))}
            </div>

            {/* Modal for adding/editing language */}
            <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
                <div className="flex items-center justify-between py-2 px-4">
                    <p>{editingLanguage?.id ? 'Modifier' : 'Ajouter'} une langue</p>
                    <button onClick={() => setShowModal(false)} className="px-2 py-2 rounded-md border text-primary-black">
                        <CgClose />
                    </button>
                </div>
                <hr className="mb-6" />
                <div className="px-6 space-y-4 mb-4">
                    <Select 
                        label="Langue" 
                        name="title"
                        placeholder="Veuillez sélectionner" 
                        options={["Anglais", "Français", "Chinois"]} 
                        value={editingLanguage?.title || ''}
                        onChange={(e) => setEditingLanguage({ ...editingLanguage, title: e.target.value })}
                    />
                    <Select 
                        label="Niveau" 
                        name="merit"
                        placeholder="Veuillez sélectionner" 
                        options={["Notion", "Débutant", "Intermédiaire", "Avancé", "Bilingue", "Natal"]} 
                        value={editingLanguage?.merit || ''}
                        onChange={(e) => setEditingLanguage({ ...editingLanguage, merit: e.target.value })}
                    />
                </div>
                <div className="flex items-center justify-end p-6">
                    <ButtonBlack isLoading={isLoading} onClick={handleSaveLanguage} className="py-2 px-6 rounded-sm shadow bg-primary-black text-white">
                        Enregistrer
                    </ButtonBlack>
                </div>
            </Modal>
        </div>
    );
};

export default Language;
